import { Box, Flex, Heading, Stack } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import HeroContainer from '@components/pages/products/common/ProductHero/HeroContainer';
import { fontSize, navMaxWidth } from '@constants/styles';
import mailIcon from '@public/flaticons/mail.svg';
import onlineStoreIcon from '@public/flaticons/online-store.svg';
import subscriptionIcon from '@public/flaticons/subscription.svg';
import { TypeformLinks } from '@utils/index';
import ContentWithImage from 'landing/ContentWithImage';
import { NextSeo } from 'next-seo';
import Image from 'next/image';
import DefaultLayout from '../components/layout/layout/DefaultLayout';

export const contentAndImage = {
  store: {
    heading: 'See all your options',
    body:
      "We've digitized the over-the-counter (OTC) catalogs for most major insurance carriers. Toothpaste, dental floss, and fitbits, oh my!",
    image: onlineStoreIcon,
    orientation: 'row',
    alt: 'Friendly health advisor explaining medicare.',
  },
  recurring: {
    heading: 'Order in one click',
    body: 'Fill up your cart, hit submit, and your order will arrive in the mail in two weeks.',
    image: subscriptionIcon,
    orientation: 'row-reverse',
    alt: 'stethoscope',
  },
  alerts: {
    heading: 'The party keeps going.',
    body: "Most OTC credits recur every month or quarter. We'll email you when you have a fresh credit to use!",
    image: mailIcon,
    orientation: 'row',
    alt: 'glowing money',
  },
};

const OTCLanding = () => {
  const cta = (
    <Button href={TypeformLinks.otc} target="_blank" w="200px">
      Get Started
    </Button>
  );

  return (
    <>
      <NextSeo
        title="Fair Square Medicare OTC"
        description="Get Free Over-the-Counter Items in Seconds."
        openGraph={{
          type: 'website',
          locale: 'en_US',
          url: 'https://www.fairsquaremedicare.com/otc-landing',
          site_name: 'Fair Square Medicare OTC',
        }}
      />
      <DefaultLayout>
        <HeroContainer>
          <Flex justifyContent="space-between" alignItems="center">
            <Box pt={[1, 20]} pb={20}>
              <Heading fontSize={fontSize.hero} mb={5}>
                Get Free Over-the-Counter Items in Seconds.
              </Heading>
              <Heading color="gray.700" fontSize="25px" mb={10}>
                Order OTC items from major Medicare Advantage carriers online.
              </Heading>
              {cta}
            </Box>
            <Box display={{ base: 'none', lg: 'block' }} px={10} w="100%">
              <Image
                src="/otc-screenshot.png"
                width={2000}
                height={1200}
                alt="Screenshot of Fair Square Medicare OTC store"
              />
            </Box>
          </Flex>
        </HeroContainer>
        <Stack maxW={navMaxWidth} m="auto" p={[4, 6, 10]} spacing="120px">
          {Object.keys(contentAndImage).map((obj, i) => (
            <ContentWithImage key={i} content={contentAndImage[obj]} />
          ))}
          <Box id="form-container" m="0px auto" textAlign="left" w="100%" py={20} bg="blue.50" px={[5, 10]}>
            <Heading fontSize={fontSize.hero} mb={10}>
              Sign Up
            </Heading>
            <Heading color="gray.700" fontSize="25px" mb={10}>
              Take control of your OTC spending and sign up to start saving money today.
            </Heading>
            {cta}
          </Box>
        </Stack>
      </DefaultLayout>
    </>
  );
};

export default OTCLanding;
